import styled from "styled-components";
import { ButtonBase, DialogTitle, Divider, Typography } from "@mui/material";

export const Heading = styled(DialogTitle)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
    margin: 0px;
    padding-top: 30px;
    padding-bottom: 10px;
  }
`;

export const DividerLine = styled(Divider)`
  && {
    padding: 1px;
    background: #00000040;
    border: 0;
    margin-left: 35px;
    margin-right: 35px;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 24px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-top: 10px;
  }
`;

export const Subtitle = styled(Typography)`
  && {
    width: 364px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    line-height: 24px;
    letter-spacing: 0.05em;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const DownloadButton = styled(ButtonBase)`
  && {
    background: #f2753b;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    padding: 13px 30px;

    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
    margin-bottom: 30px;
  }
`;
